import React from 'react';
import { HelpCircleIcon, MoonIcon, RepeatIcon, SearchIcon, ShieldAlertIcon, TimerIcon } from 'lucide-react';
import { recognizeItems } from '../data/content';
const icons = {
  time: TimerIcon,
  cue: HelpCircleIcon,
  repeat: RepeatIcon,
  search: SearchIcon,
  caution: ShieldAlertIcon,
  moon: MoonIcon
};
export function Recognize() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-24" data-id="element-174" data-mp="2r5ke45kim5g4">
      <div className="mx-auto max-w-4xl" data-id="element-175" data-mp="2m93eof7v84nq">
        <div className="text-center" data-id="element-176" data-mp="2i6qahv8roet2">
          <h2 className="font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-177" data-mp="2i5nkrqn6kieq">
            Do You Recognize Yourself in These Situations?
          </h2>
          <p className="mt-3 text-sm text-ink/55" data-id="element-178" data-mp="289c7oyfrnoj8">
            If you said yes to any of these — this pack is for you.
          </p>
        </div>

        <ul className="mt-9 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-179" data-mp="be6aa6luf078">
          {recognizeItems.map(item => {
          const Icon = icons[item.icon];
          return <li key={item.text} className="flex items-start gap-3 rounded-xl bg-white px-4 py-4" data-id="element-180" data-mp="3jjirdi6gb0rj">
                <Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-181" data-mp="39n5yunmn6syd" />
                <span className="text-xs font-medium leading-snug text-ink/80" data-id="element-182" data-mp="3emsbovyk676n">
                  {item.text}
                </span>
              </li>;
        })}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-183" data-mp="b48seixuybnz">
          And you deserve so much more than that →
        </p>
      </div>
    </section>;
}